import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: `linear-gradient(135deg, #3D2C8D 0%, #4A3B9A 30%, #3D2C8D 70%, #2A1F6B 100%)`
      }}
    >
      {/* Enhanced animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-r from-amber-400/20 to-yellow-300/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute top-40 right-20 w-24 h-24 bg-gradient-to-r from-amber-500/15 to-yellow-400/15 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-32 left-1/3 w-40 h-40 bg-gradient-to-r from-amber-300/10 to-yellow-200/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        
        {/* Floating particles */}
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-amber-400/40 rounded-full animate-ping" style={{ animationDelay: '0.5s' }}></div>
        <div className="absolute top-3/4 right-1/4 w-1 h-1 bg-yellow-300/60 rounded-full animate-ping" style={{ animationDelay: '1.5s' }}></div>
        <div className="absolute top-1/2 left-3/4 w-3 h-3 bg-amber-500/30 rounded-full animate-pulse" style={{ animationDelay: '2.5s' }}></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-8">
            {/* Crown Icon with animation */}
            <div className="inline-block p-4 rounded-full bg-gradient-to-r from-amber-400/20 to-yellow-300/20 backdrop-blur-sm border border-amber-400/30 animate-pulse">
              <i className="ri-crown-line text-3xl" style={{ color: '#F5A623' }}></i>
            </div>

            <h1 className="text-5xl lg:text-7xl font-bold leading-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
              Master Your
              <span className="block text-6xl lg:text-8xl bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent animate-pulse">
                CROWN
              </span>
              <span className="block text-4xl lg:text-5xl text-white">
                of Abundance
              </span>
            </h1>
            
            <div className="space-y-4">
              <p className="text-xl lg:text-2xl leading-relaxed" style={{ color: '#FFFFFF' }}>
                Become part of a global movement for transformation of <strong style={{ color: '#F5A623' }}>wealth</strong>, <strong style={{ color: '#F5A623' }}>relationships</strong>, and <strong style={{ color: '#F5A623' }}>generational legacy</strong>
              </p>
              
              <p className="text-lg leading-relaxed text-white/80">
                <span style={{ color: '#F5A623' }}>Collaborative Restoration Of Wealth and Nations</span> - House of CROWN
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => navigate('/membership')}
                className="group bg-gradient-to-r from-amber-500 to-yellow-400 hover:from-amber-600 hover:to-yellow-500 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                <i className="ri-crown-line mr-2 group-hover:animate-pulse"></i>
                Claim Your Crown
              </button>
              <button 
                onClick={() => navigate('/about')}
                className="border-2 border-amber-400 text-amber-400 hover:bg-amber-400 hover:text-purple-900 px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:-translate-y-1"
              >
                <i className="ri-play-circle-line mr-2"></i>
                Our Story
              </button>
            </div>
            
            {/* Enhanced Values - Honest representation */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/20">
              <div className="text-center group">
                <div className="text-3xl font-bold mb-1 group-hover:scale-110 transition-transform duration-300" style={{ color: '#F5A623' }}>
                  <i className="ri-global-line"></i>
                </div>
                <div className="text-sm text-white/80">Global Community</div>
              </div>
              <div className="text-center group">
                <div className="text-3xl font-bold mb-1 group-hover:scale-110 transition-transform duration-300" style={{ color: '#F5A623' }}>
                  <i className="ri-team-line"></i>
                </div>
                <div className="text-sm text-white/80">Collaborative Growth</div>
              </div>
              <div className="text-center group">
                <div className="text-3xl font-bold mb-1 group-hover:scale-110 transition-transform duration-300" style={{ color: '#F5A623' }}>
                  <i className="ri-trophy-line"></i>
                </div>
                <div className="text-sm text-white/80">Legacy Building</div>
              </div>
            </div>
          </div>
          
          <div className="hidden lg:block relative">
            <div className="relative w-full h-96 group">
              <img 
                src="https://public.readdy.ai/ai/img_res/173d6dc261db533612174a4cca932e82.jpg"
                alt="Crown of Abundance"
                className="w-full h-full object-cover rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-900/40 to-transparent rounded-2xl"></div>
              
              {/* Floating elements on image */}
              <div className="absolute top-4 right-4 w-6 h-6 bg-amber-400/60 rounded-full animate-ping"></div>
              <div className="absolute bottom-4 left-4 w-4 h-4 bg-yellow-300/50 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Enhanced scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="flex flex-col items-center">
          <i className="ri-arrow-down-line text-2xl mb-2" style={{ color: '#F5A623' }}></i>
          <div className="text-xs text-white/60">Explore</div>
        </div>
      </div>
    </section>
  );
}
